module.exports = __webpack_public_path__ + "img/mapalunagranada.8dd82ce3.png";